module.exports = __webpack_public_path__ + "static/nalfeshnee-726ac106d88c16ac19795d7f22086da9.jpeg";